module.exports = __webpack_public_path__ + "img/team-4-modal.c2e811e0.jpg";